/**
 * Return true if the input is null, not an array, or an empty array.
 * 
 * @param {*} arrayToCheck 
 * @returns 
 */
export const arrayIsNullOrEmpty = (arrayToCheck) => {
  let result = true
  if (arrayToCheck != null && arrayToCheck !== undefined && Array.isArray(arrayToCheck) && arrayToCheck.length > 0) {
    result = false
  }
  return result
}

/**
 * Append http to an invalid url
 * @param {string} url Url to format
 */
export const sanitizeUrl = (url) => {
  if (url && !url.startsWith('http')){
    return `http://${url}`
  }
  return url
}

/**
 * Append http to an invalid url
 * @param {string} url Url to format
 */
export const sanitizeEquitySupportUrl = (url, pathname, zip) => {
  let uri  = url.replace('{pathname}', pathname)
  uri = uri.replace('{zip}', zip || '')
  return uri
}

export const mapAddressTypeNameToCategory = (typeName) => {
  let typeToCheck, returnType
  if (typeName) {
    typeToCheck = typeName.toLowerCase()
  }
  switch (typeToCheck){
  case 'session':
    returnType = 'session'
    break
  case 'worksite':
    returnType = 'worksite'
    break
  case 'partner':
    returnType = 'partner'
    break
  case 'educational institution':
  case 'institution':
  case 'class site':
    returnType = 'institution'
    break
  case 'how to apply contact':
    returnType = 'how_to_apply'
    break
  case 'program contact':
  case 'contact':
    returnType = 'contact'
    break
  default:
    returnType = ''
  }
  return returnType
}

export const filterAddressesByCategory = (addresses, category) => {
  if (arrayIsNullOrEmpty(addresses) || !category){
    return []
  }
  let categoryFilter = category
  if (!Array.isArray(category)) {
    categoryFilter = [ category, ]
  }

  return addresses.filter(a => {
    if (a && a.type) {
      return (categoryFilter.includes(mapAddressTypeNameToCategory(a.type)))
    }
    return false
  })
}

export const isString = (varToCheck) => typeof varToCheck === 'string' || varToCheck instanceof String

/**
  Handle an error response mapping to string.
  API may return an error message in an 'error' key,
  if present, use it.
*/
export function getErrorResponseString (response) {
  if (response && response.response) {
    const resp = response.response
    if (resp.data) {
      const { data, } = resp
      if (isString(data)) {
        return data
      }
      if (isString(data.error)) {
        return data.error
      } 
      if (typeof data === 'object') {
        let errorString = ''
        for (const key in data){
          if (Array.isArray(data[key])) {
            errorString = data[key].reduce((acc, curr) => { 
              acc += `${acc.length > 0 ? '\n' : ''}${curr}`
              return acc 
            }, errorString)
          } else if (typeof data[key] === 'string') {
            errorString += data[key]
          }
        }
        return errorString
      }
    }
  }
  return response.toString()
}


export function getBootstrapSize (defaultSize = 12, base = null) {
  if (!base) {
    return {
      xs : defaultSize,
      sm : defaultSize,
      md : defaultSize,
      lg : defaultSize,
      xl : defaultSize,
    }
  } else {
    return {
      xs : !isNaN(base.xs) ? base.xs : defaultSize,
      sm : !isNaN(base.sm) ? base.sm : defaultSize,
      md : !isNaN(base.md) ? base.md : defaultSize,
      lg : !isNaN(base.lg) ? base.lg : defaultSize,
      xl : !isNaN(base.xl) ? base.xl : defaultSize,
    }
  }
}

export function bootstrapSizeRemainder (size) {
  const remainder = getBootstrapSize(12)
  if (!size) {
    return remainder
  }
  return {
    xs : size.xs === 12 ? 12 : 12 - size.xs,
    sm : size.sm === 12 ? 12 : 12 - size.sm,
    md : size.md === 12 ? 12 : 12 - size.md,
    lg : size.lg === 12 ? 12 : 12 - size.lg,
    xl : size.xl === 12 ? 12 : 12 - size.xl,
  }
}

export function ScrollAndPostScrollTop () {
  window.scrollTo(0, 0)
  window.parent.postMessage('ScrollTop', '*')
}

module.exports = { arrayIsNullOrEmpty, sanitizeUrl, mapAddressTypeNameToCategory, ScrollAndPostScrollTop, filterAddressesByCategory, sanitizeEquitySupportUrl, isString, getErrorResponseString, getBootstrapSize, bootstrapSizeRemainder, }